import { cloneElement, ReactElement } from "react";

import usePresentModeContext from "@/view/utils/usePresentModeContext";
import { rootCss } from "./StickyBar.style";
import useIsStuckVertically from "./useIsStuckVertically";

interface StickyBarProps {
  id?: string;
  children: ReactElement<{ isStuck?: boolean }>;
}

const StickyBar = ({ id, children }: StickyBarProps) => {
  const { isVideoPresentModeActive } = usePresentModeContext();
  const { ref, isStuck } = useIsStuckVertically();

  return (
    <div id={id} css={rootCss(isVideoPresentModeActive)} ref={ref}>
      {cloneElement(children, { isStuck })}
    </div>
  );
};

export default StickyBar;
